import { VipTaskTypesEnum } from '@shared/constants';

import { VipTaskFormValues } from './types';

export const VIP_TASK_FORM_INITIAL_VALUES: VipTaskFormValues = {
  title: '',
  imageId: '',
  link: '',
  promoCode: '',
  ymId: '',
  casinoName: '',
  type: VipTaskTypesEnum.PLATFORM,
  marks: [],
  isActive: false,
};
